import I18n from 'I18n';
import { useContext } from 'react';
import ExportReportButton from 'reporting-action-components/reportingActions/exportReport/ExportReportButton';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { List } from 'foundations-components/transitional/components/List';
// @ts-expect-error untyped module
import SaveReportButton from 'reporting-action-components/reportingActions/saveReport/SaveReportButton';
import { ViewInDatasetsButton } from 'reporting-action-components/reportingActions/viewInDatasets/ViewInDatasetsButton';
import { getReportChartType } from 'reporting-data/report/reportGetters';
import { isRelationalReport } from 'reporting-data/tsTypes/reportTypes';
import { EnablementTrackingContext } from '../../../../monitoring/EnablementTrackingContext';
import { SRVTableActionsMenuButton } from './SRVTableActionsMenuButton';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SRVTableActionsMenu = ({
  report,
  showViewInDatasets,
  selectedReport
}) => {
  var _getReportChartType;
  const {
    appUsageTracker,
    trackingApplicationName,
    trackingAssetType,
    trackingScreenName,
    trackingSubscreenName
  } = useContext(EnablementTrackingContext);
  if (!report) {
    return null;
  }
  const trackingProperties = {
    assetType: trackingAssetType,
    applicationName: trackingApplicationName,
    screen: trackingScreenName,
    subscreen: trackingSubscreenName,
    interactionSource: 'actions-dropdown'
  };
  const menuButtonName = I18n.text('widget.actionsLabel');
  return /*#__PURE__*/_jsx(Tooltip, {
    title: menuButtonName,
    children: /*#__PURE__*/_jsx(Dropdown, {
      Button: SRVTableActionsMenuButton,
      "aria-label": menuButtonName,
      buttonStyles: {
        // This must be specified here and not as a prop on the button or it will be ignored
        // Padding must be applied internally somehow and not as a prop to the button
        padding: '0'
      },
      children: /*#__PURE__*/_jsxs(List, {
        wrapChildren: true,
        children: [showViewInDatasets && isRelationalReport(report) && /*#__PURE__*/_jsx(ViewInDatasetsButton, {
          appUsageTracker: appUsageTracker,
          report: report,
          trackingProperties: trackingProperties
        }), /*#__PURE__*/_jsx(SaveReportButton, {
          appUsageTracker: appUsageTracker,
          report: report,
          tooltipPlacement: "top",
          "data-test-id": "report-actions-save",
          trackingProperties: trackingProperties
        }), /*#__PURE__*/_jsx(ExportReportButton, {
          appUsageTracker: appUsageTracker,
          report: report,
          trackingProperties: Object.assign({}, trackingProperties, {
            // cast null back to undefined
            chartType: (_getReportChartType = getReportChartType(report)) !== null && _getReportChartType !== void 0 ? _getReportChartType : undefined,
            selectedReport
          })
        })]
      })
    })
  });
};